<!-- <div class="body ui container" fxLayout="column"> -->
<div fxLayout="row" fxLayoutAlign="space-between center" class="top">
  <div
    fxLayoutAlign="start center"
    fxLayout="row"
    fxLayoutGap="20px"
    class="link"
  >
    <!-- <div >
                    <img src="assets/icons/left-arrow-icon.svg" alt="">
                </div> -->
    <div class="equipment-id">
      <!-- Title -->
      <h2 class="ui primary header">Account Security</h2>
    </div>
  </div>
</div>

<div class="ui divider" appMargin marginY="3"></div>
<div *ngIf="success || error" tamsyMargin marginY="10px">
  <esl-message-toast [(message)]="error"></esl-message-toast>
  <esl-message-toast
    [(message)]="success"
    [messageType]="'success'"
  ></esl-message-toast>
</div>

<div class="ui basic segment" appMargin marginT="0">
  <h2>Change Password</h2>
  <div class="ui divider"></div>
  <div fxLayout="row">
    <div
      fxFlex="50%"
      class="ui form"
      [formGroup]="accountForm"
      [ngClass]="{ loading: pending }"
    >
      <p appMargin marginB="5">
        Please enter your current password to change your password
      </p>
      <div class="field required">
        <label>Current Password:</label>
        <input
          placeholder="Old Password"
          type="password"
          formControlName="oldPassword"
        />
        <div
          *ngIf="
            accountForm.controls['oldPassword'].dirty &&
            accountForm.controls['oldPassword'].hasError('strongPassword')
          "
          class="ui pointing red basic label"
        >
          Password must be more than 8 characters, must contain 1 uppercase, 1
          lowercase ,1 number and 1 special character
        </div>
        <app-field-error-display
          [displayError]="isFieldValid('oldPassword')"
          errorMsg="Please enter your old password"
        >
        </app-field-error-display>
      </div>
      <div class="field required">
        <label>Password:</label>
        <input
          placeholder="Password"
          type="password"
          formControlName="password"
        />
        <div
          *ngIf="
            accountForm.controls['password'].dirty &&
            accountForm.controls['password'].hasError('strongPassword')
          "
          class="ui pointing red basic label"
        >
          Password must be more than 8 characters, must contain 1 uppercase, 1
          lowercase,1 number and 1 special character
        </div>
        <app-field-error-display
          [displayError]="isFieldValid('password')"
          errorMsg="Please enter password"
        >
        </app-field-error-display>
      </div>
      <div class="field required">
        <label>Confirm Password:</label>
        <input
          placeholder="Confirm Password"
          type="password"
          formControlName="confirmPassword"
        />
        <div
          *ngIf="accountForm.controls['confirmPassword'].hasError('minlength')"
          class="ui pointing red basic label"
        >
          Password must be more than 8 characters
        </div>
        <div
          *ngIf="
            accountForm.controls['confirmPassword'].dirty &&
            accountForm.errors &&
            accountForm.errors['matchingPasswords']
          "
        >
          <div
            *ngIf="accountForm.errors['matchingPasswords']"
            class="ui pointing red basic label"
          >
            Passwords do not match
          </div>
        </div>
        <app-field-error-display
          [displayError]="isFieldValid('confirmPassword')"
          errorMsg="Please enter confirm password"
        >
        </app-field-error-display>
      </div>
      <div class="field" appMargin marginY="5">
        <button class="ui basic black button" (click)="submit()">
          Update Password
        </button>
      </div>
    </div>
  </div>

  <div fxLayout="row" appMargin marginT="5">
    <div fxFlex="50%">
      <h2>Two-factor Authentication</h2>
    </div>
    <div
      fxFlex="50%"
      class="text-right"
      style="
        display: flex;
        justify-content: flex-end;
        align-items: center;
        gap: 14px;
      "
    >
      <ng-template [ngIf]="user">
        <p
          style="
            color: #3f4395;
            font-family: Roboto;
            font-size: 16px;
            font-style: normal;
            font-weight: 500;
            line-height: 20px; /* 125% */
            text-decoration-line: underline;
            cursor: pointer;
            margin: 0;
          "
          *ngIf="usedRecoveryCode && user.totpEnabled"
          (click)="configureModal()"
        >
          Re-Configure 2FA
        </p>
        <p
          style="
            color: #3f4395;
            font-family: Roboto;
            font-size: 16px;
            font-style: normal;
            font-weight: 500;
            line-height: 20px; /* 125% */
            text-decoration-line: underline;
            cursor: pointer;
            margin: 0;
          "
          *ngIf="
            user.totpEnabled &&
            toggleChange &&
            FADetails &&
            FADetails?.provider === 'APP' &&
            FADetails?.provider !== 'EMAIL'
          "
          (click)="getRecoveryCode()"
        >
          Recovery codes
        </p>
        <p
          style="
            color: #3f4395;
            font-family: Roboto;
            font-size: 16px;
            font-style: normal;
            font-weight: 500;
            line-height: 20px; /* 125% */
            text-decoration-line: underline;
            cursor: pointer;
            margin: 0;
          "
          *ngIf="
            user.totpEnabled && FADetails && FADetails?.provider === 'EMAIL'
          "
          (click)="configureModal()"
        >
          Configure 2FA
        </p>
        <sui-checkbox
          [(ngModel)]="user.totpEnabled"
          class="toggle two_factor"
          [isDisabled]="
            (user.totpEnabled &&
              FADetails &&
              FADetails?.provider === 'EMAIL') ||
            (usedRecoveryCode && user.totpEnabled) ||
            organization.totpEnabled
          "
          (checkChange)="toggle($event)"
        ></sui-checkbox>
        <img
          src="../../../../../assets/icons/Question.svg"
          alt="data"
          suiPopup
          *ngIf="
            user.totpEnabled && FADetails && FADetails?.provider === 'EMAIL'
          "
          [popupInverted]="true"
          popupPlacement="bottom"
          popupText="2FA has been enabled at the organizational level, and you are unable to disable this setting. If you want to change the status of the settings, please reach out to the system administrator."
        />
        <img
          src="../../../../../assets/icons/Question.svg"
          alt="data"
          suiPopup
          *ngIf="usedRecoveryCode && user.totpEnabled"
          [popupInverted]="true"
          popupPlacement="bottom"
          popupText="2FA has been enabled , and you are unable to disable this setting. If you want to change the status of the settings, please reach out to the system administrator."
        />
      </ng-template>
    </div>
  </div>

  <div class="ui divider"></div>
  <p appMargin marginB="15">
    Two-factor Authentication would make more difficult for third party to gain
    access to your account
  </p>
</div>
<!-- </div> -->
